import * as Sentry from '@sentry/react'
import localForage from 'localforage'
import { routerMiddleware } from 'react-router-redux'
import { applyMiddleware, compose, createStore } from 'redux'
import { persistStore, autoRehydrate } from 'redux-persist'
import { responsiveStoreEnhancer } from 'redux-responsive'
import thunkMiddleware from 'redux-thunk'

import routerHistory from '../utils/routing/history'

import rootReducer from './rootReducer'

const sentryReduxEnhancer = Sentry.createReduxEnhancer()

const store = createStore(
  rootReducer,
  {},
  compose(
    applyMiddleware(thunkMiddleware, routerMiddleware(routerHistory)),
    sentryReduxEnhancer,
    autoRehydrate(),
    responsiveStoreEnhancer,
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
      : f => f,
  ),
)

const reduxPersistOptions = {
  storage: localForage,
  blacklist: ['demo'],
  whitelist: ['currentUser', 'insToken'],
}

export const persist = () =>
  // change to '...resolve).purge())'   to remove the current user session
  new Promise(resolve => persistStore(store, reduxPersistOptions, resolve))

export default store



// WEBPACK FOOTER //
// ./src/store/configureStore.js